<template>
  <div class="hello">
    <h1>Hästkapplöpning</h1>
<div class="tärningsfält">

    <div class="tärning">
        <div class="ytterram tärning1"  id="tärning1">
            <div id="1öga1" class="öga öga1 ögon1">     </div>
            <div id="1öga2" class="öga öga2 ögon1">     </div>
            <div id="1öga3" class="öga öga3 ögon1">     </div>
            <div id="1öga4" class="öga öga4 ögon1">     </div>
            <div id="1öga5" class="öga öga5 ögon1">     </div>
            <div id="1öga6" class="öga öga6 ögon1">     </div>
            <div id="1öga7" class="öga öga7 ögon1">     </div>

        </div>

    </div>


    <div class="tärning">
        <div class="ytterram tärning2" id="tärning2">
            <div id="2öga1" class="öga öga1 ögon2">     </div>
            <div id="2öga2" class="öga öga2 ögon2">     </div>
            <div id="2öga3" class="öga öga3 ögon2">     </div>
            <div id="2öga4" class="öga öga4 ögon2">     </div>
            <div id="2öga5" class="öga öga5 ögon2">     </div>
            <div id="2öga6" class="öga öga6 ögon2">     </div>
            <div id="2öga7" class="öga öga7 ögon2">     </div>

        </div>

    </div>

    <h1 id="vinnare">Häst {{vinnare}} vann!!</h1>

    <br>
    <div class="raka">
        <div class="vänster"><b>START</b></div>
    <button v-on:click="kasta()">---Kasta tärningarna---</button>
    <div class="höger"><b>MÅL</b></div>
</div>

    <div id="bana2" class="bana2 bana">
        häst 2
        <div class="häst" id="häst2"><img src="../assets/häst.png"  width="32" height="32"></div>
    </div>

    <div id="bana3" class="bana3 bana">häst 3
        <div  class="häst" id="häst3"><img src="../assets/häst.png"  width="32" height="32"></div>
    </div>

    <div id="bana4" class="bana4 bana">häst 4
        <div  class="häst" id="häst4"><img src="../assets/häst.png"  width="32" height="32"></div>
    </div>

    <div id="bana5" class="bana5 bana">häst 5
        <div  class="häst" id="häst5"><img src="../assets/häst.png"  width="32" height="32"></div>
    </div>

    <div  id="bana6" class="bana6 bana">häst 6
        <div  class="häst" id="häst6"><img src="../assets/häst.png"  width="32" height="32"></div>
    </div>

    <div  id="bana7" class="bana7 bana">häst 7
        <div  class="häst" id="häst7"><img src="../assets/häst.png"  width="32" height="32"></div>
    </div>

    <div  id="bana8" class="bana8 bana">häst 8
        <div  class="häst" id="häst8"><img src="../assets/häst.png"  width="32" height="32"></div>
    </div>

    <div  id="bana9" class="bana9 bana">häst 9
        <div  class="häst" id="häst9"><img src="../assets/häst.png"  width="32" height="32"></div>
    </div>

    <div  id="bana10" class="bana10 bana">häst 10
        <div  class="häst" id="häst10"><img src="../assets/häst.png"  width="32" height="32"></div>
    </div>

    <div  id="bana11" class="bana11 bana">häst 11
        <div  class="häst" id="häst11"><img src="../assets/häst.png"  width="32" height="32"></div>
    </div>

    <div  id="bana12" class="bana12 bana">häst 12
        <div  class="häst" id="häst12"><img src="../assets/häst.png"  width="32" height="32"></div>
    </div>



</div>





  </div>
</template>

<script>
export default {
  name: 'StartPage',
  props: {
    msg: String
},
data() {
    return {
        hästpositioner: [0,0,0,0,0,0,0,0,0,0,0,0,0],
        summa:0,
        vinnare:0,
        oavgjort: true,
        knappAktiv: true
    }
},
methods: {
    uppdateraHästar: function(){
        for (var i=2; i<=12; i++) {
            document.getElementById("häst" + i).style.left = (this.hästpositioner[i]*8)+"%";
            if (this.hästpositioner[i]==12) {
                this.vinnare=i;
                document.getElementById("vinnare").style.display = "inline";
                this.oavgjort = false;
                document.getElementById("bana" + i).classList.add("pulserande");
            }

        }

    },
    kasta: function(){
        if(this.oavgjort && this.knappAktiv) {
            var t1 = document.getElementsByClassName("ytterram");

            this.suddaÖgon();
            this.knappAktiv = false;
            t1[0].classList.add("rotating");
            t1[1].classList.add("rotating");


            var that = this;
            var slump1 = Math.floor(Math.random() * 6)+1;
            var slump2 = Math.floor(Math.random() * 6)+1;
            this.summa = slump1 + slump2;

             setTimeout(function(){
                 t1[0].classList.remove("rotating");
                 t1[1].classList.remove("rotating");

                 that.tärning1(slump1);
                 that.tärning2(slump2);
                 that.hästpositioner[that.summa]++;
                 that.uppdateraHästar();
                 that.knappAktiv = true;

             }, 300);
        }


    },
    suddaÖgon: function(){
        var ögon1=document.getElementsByClassName("ögon1");
        var ögon2=document.getElementsByClassName("ögon2");

        for(var i=0; i<7; i++) {
            ögon1[i].classList.remove("synlig");
            ögon2[i].classList.remove("synlig");
        }

    },
    tärning1: function(nummer) {
        var ögon1=document.getElementsByClassName("ögon1");



        if(nummer == 1) {
            ögon1[3].classList.add("synlig");
        } else if (nummer == 2) {
            ögon1[0].classList.add("synlig");
            ögon1[6].classList.add("synlig");
        } else if (nummer == 3) {
            ögon1[0].classList.add("synlig");
            ögon1[3].classList.add("synlig");
            ögon1[6].classList.add("synlig");
        } else if (nummer == 4) {
            ögon1[0].classList.add("synlig");
            ögon1[4].classList.add("synlig");
            ögon1[2].classList.add("synlig");
            ögon1[6].classList.add("synlig");
        } else if (nummer == 5) {
            ögon1[0].classList.add("synlig");
            ögon1[4].classList.add("synlig");
            ögon1[3].classList.add("synlig");
            ögon1[2].classList.add("synlig");
            ögon1[6].classList.add("synlig");
        } else if (nummer == 6) {
            ögon1[0].classList.add("synlig");
            ögon1[1].classList.add("synlig");
            ögon1[2].classList.add("synlig");

            ögon1[4].classList.add("synlig");
            ögon1[5].classList.add("synlig");
            ögon1[6].classList.add("synlig");
        }
    },
    tärning2: function(nummer) {
        var ögon2=document.getElementsByClassName("ögon2");



        if(nummer == 1) {
            ögon2[3].classList.add("synlig");
        } else if (nummer == 2) {
            ögon2[0].classList.add("synlig");
            ögon2[6].classList.add("synlig");
        } else if (nummer == 3) {
            ögon2[0].classList.add("synlig");
            ögon2[3].classList.add("synlig");
            ögon2[6].classList.add("synlig");
        } else if (nummer == 4) {
            ögon2[0].classList.add("synlig");
            ögon2[4].classList.add("synlig");
            ögon2[2].classList.add("synlig");
            ögon2[6].classList.add("synlig");
        } else if (nummer == 5) {
            ögon2[0].classList.add("synlig");
            ögon2[4].classList.add("synlig");
            ögon2[3].classList.add("synlig");
            ögon2[2].classList.add("synlig");
            ögon2[6].classList.add("synlig");
        } else if (nummer == 6) {
            ögon2[0].classList.add("synlig");
            ögon2[1].classList.add("synlig");
            ögon2[2].classList.add("synlig");

            ögon2[4].classList.add("synlig");
            ögon2[5].classList.add("synlig");
            ögon2[6].classList.add("synlig");
        }
    }
},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.raka {
    position: relative;
    margin: 5px;
}

.höger {
    position: absolute;
    display: inline;
    right:0;
    color:black;
}


.vänster {
    position: absolute;
    display: inline;
    left:0;
    color:black;
}

.bana {
    position: relative;
    height: 40px;
    display: block;
    border-top: solid 1px;
    border-bottom: solid 1px;
    color:black;
}

#vinnare {
    display:none;
    position: absolute;
    left: 20px;
    color: purple;
}
.häst {
    position: absolute;

    bottom:3px;
    transition: left 0.2s;
}

.bana2 {
    background-color: lightgreen;
}

.bana3 {
    background-color: pink;
}

.bana4 {
    background-color: lightyellow;
}

.bana5 {
    background-color: lightblue;
}

.bana6 {
    background-color: lightgrey;
}

.bana7 {
    background-color: #A5A;
}

.bana8 {
    background-color: #AA0;
}

.bana9 {
    background-color: cyan;
}

.bana10 {
    background-color: white;
}

.bana11 {
    background-color: lightcyan;
}

.bana12 {
    background-color: pink;
}


h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.hello {
    min-height: calc(100vh - 71px);
}

.tärning {
    display: inline;
    margin: 10px;
}

#tärning1 {

}

#tärning2 {

}


.tärning1 {
    background-color: lightgreen;
}

.tärning2 {
    background-color: pink;
}



.ytterram {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 60px;

    border-radius: 10px;
    border: solid black 1px;
}
.öga {
    position: absolute;
    border-radius: 10px;
    width: 15px;
    height: 15px;
    background-color: black;
    display: none;
}

.öga1 {
    top: 5px;
    left:5px;
}

.öga2 {
    top: 23px;
    left:5px;
}

.öga3 {
    bottom: 5px;
    left:5px;
}


.öga4 {
    top: 23px;
    left:23px;
}


.öga5 {
    top: 5px;
    right:5px;
}
.öga6 {
    top: 23px;
    right:5px;
}
.öga7 {
    bottom: 5px;
    right:5px;
}

.snurr1 {

}

button {
    border: solid 2px;
    border-radius: 10px;
    padding:3px;
}
button:hover {
    background-color: white;
}
.fuckad {
    transform: rotate(48deg);
}
@-webkit-keyframes rotating /* Safari and Chrome */ {
  from {
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes rotating {
  from {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.rotating {
  -webkit-animation: rotating 0.5s linear infinite;
  -moz-animation: rotating 0.5s linear infinite;
  -ms-animation: rotating 0.5s linear infinite;
  -o-animation: rotating 0.5s linear infinite;
  animation: rotating 0.5s linear infinite;
}
.synlig {
    display: block;
}

.pulserande {
    /*background-color: #222;*/
    animation-name: color;
    animation-duration: 1.5s;
    animation-iteration-count: infinite;
}

@keyframes color {
/*  0% {
    background-color: #222;
  }
  50% {
    background-color: #4285f4;
  }
  100 {
    background-color: #222;
  }*/
    0% {
      color: #000;
    }
    50% {
      color: #FFF;
    }
    100% {
      color: #000;
    }

}

</style>
